import Vue from 'vue'
import App from './App'
import router from './router'
import './utils/validate'
import {
	required,
	num
} from "@/utils/validate"
import ElementUI from 'element-ui' // 2.1引入结构
import 'element-ui/lib/theme-chalk/index.css' // 2.2引入样式
import './assets/public.css' //自定义公共样式
import Layout from './components/Layout.vue'
import {
	Button
} from "element-ui"
import "./element.js"
import './assets/font.css'

//全局配置请求
import util from './utils/util.js'
Vue.prototype.util = util

Vue.config.productionTip = false
Vue.use(ElementUI); // 3.安装
/* eslint-disable no-new */
new Vue({
	el: '#app',
	router,
	render: h => h(Layout)
});


// WEBPACK FOOTER //
// ./src/main.js